import {APP_CLIENT_ID, COGNITO_DOMAIN, IDENTITY_POOL_ID, REGION, STAGE, USER_POOL_ID} from "src/app/config/EnvConfig";
import {Region, Stage} from "src/app/constant/Enums";

export const COGNITO_CONFIG = {
    REGION: REGION,
    USER_POOL_ID: USER_POOL_ID,
    APP_CLIENT_ID: APP_CLIENT_ID,
    IDENTITY_POOL_ID: IDENTITY_POOL_ID,
    COGNITO_DOMAIN: COGNITO_DOMAIN
}

let EEP_API_URL_MAP: { [stage: string]: { [region: string]: { endpoint: string } } } = {
    [Stage.BETA]: {
        [Region.NA]: {
            endpoint: 'https://api-eep.beta-na.flex-altitude-irm.last-mile.amazon.dev'
        },
        [Region.EU]: {
            endpoint: 'https://api-eep.beta-eu.flex-altitude-irm.last-mile.amazon.dev'
        },
        [Region.FE]: {
            endpoint: 'https://api-eep.beta-fe.flex-altitude-irm.last-mile.amazon.dev'
        }
    },
    [Stage.GAMMA]: {
        [Region.NA]: {
            endpoint: 'https://api-eep.gamma-na.flex-altitude-irm.last-mile.amazon.dev'
        },
        [Region.EU]: {
            endpoint: 'https://api-eep.gamma-eu.flex-altitude-irm.last-mile.amazon.dev'
        },
        [Region.FE]: {
            endpoint: 'https://api-eep.gamma-fe.flex-altitude-irm.last-mile.amazon.dev'
        }
    },
    [Stage.PROD]: {
        [Region.NA]: {
            endpoint: 'https://api-eep.prod-na.flex-altitude-irm.last-mile.amazon.dev'
        },
        [Region.EU]: {
            endpoint: 'https://api-eep.prod-eu.flex-altitude-irm.last-mile.amazon.dev'
        },
        [Region.FE]: {
            endpoint: 'https://api-eep.prod-fe.flex-altitude-irm.last-mile.amazon.dev'
        }
    }
}

export const EEP_API = `EEP_API`;
export const EEP_API_NAME = `${EEP_API}_${STAGE}_${REGION}`;

export const GENERATE_API_ENDPOINTS = () => {
    const result = [];
    result.push({
        name: EEP_API_NAME,
        endpoint: EEP_API_URL_MAP[STAGE.toLowerCase()][convertAwsRegion(REGION)].endpoint,
        region: REGION
    });
    return result;
}

export function convertAwsRegion(awsRegion: string) {
    if ('us-west-2' == awsRegion) {
        return Region.FE;
    }
    if ('eu-west-1' == awsRegion) {
        return Region.EU;
    }
    return Region.NA;
}
